"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _namespaceComponent = require("@ux/namespace-component");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * Render a UXIcon.
 *
 * @displayName Icon
 * @class Icon
 * @public
 */
class Icon extends _namespaceComponent.NamespaceConsumer {
  render() {
    const style = {};
    const {
      name,
      color,
      size
    } = this.props;
    const classNames = this.namespace('uxicon', 'uxicon-' + name);
    if (size) style.fontSize = size;
    if (color) style.color = color;
    return /*#__PURE__*/_react.default.createElement("span", {
      style: style,
      className: classNames
    });
  }

}
/**
 * PropType validation.
 *
 * @type {Object}
 * @public
 */


Icon.propTypes = _objectSpread(_objectSpread({}, _namespaceComponent.NamespaceShape), {}, {
  /** Name of the icon */
  name: _propTypes.default.string.isRequired,

  /** Color of the button */
  color: _propTypes.default.string,

  /** Size of the button */
  size: _propTypes.default.number
});

var _default = (0, _namespaceComponent.withNamespace)(Icon);

exports.default = _default;